/**
 * Función para crear URLs seguras para productos
 * Escapa caracteres especiales y los convierte en formato URL-friendly
 * @param {string} titulo - El título del producto
 * @returns {string} - Título escapado para URL
 */
export function escapeProductTitle(titulo) {
    if (!titulo) return '';
    
    return titulo
        // Reemplazar caracteres especiales problemáticos
        .replace(/[\/\\]/g, '-') // Reemplazar / y \ con -
        .replace(/[&]/g, 'y') // Reemplazar & con 'y'
        .replace(/[#]/g, 'num') // Reemplazar # con 'num'
        .replace(/[%]/g, 'porc') // Reemplazar % con 'porc'
        .replace(/[+]/g, 'mas') // Reemplazar + con 'mas'
        .replace(/[=]/g, 'igual') // Reemplazar = con 'igual'
        .replace(/[@]/g, 'arroba') // Reemplazar @ con 'arroba'
        .replace(/[!]/g, '') // Eliminar !
        .replace(/[?]/g, '') // Eliminar ?
        .replace(/[;]/g, '') // Eliminar ;
        .replace(/[:]/g, '') // Eliminar :
        .replace(/["]/g, '') // Eliminar comillas dobles
        .replace(/[']/g, '') // Eliminar comillas simples
        .replace(/[`]/g, '') // Eliminar backticks
        .replace(/[~]/g, '') // Eliminar ~
        .replace(/[\^]/g, '') // Eliminar ^
        .replace(/[|]/g, '') // Eliminar |
        .replace(/[{}]/g, '') // Eliminar {}
        .replace(/[\[\]]/g, '') // Eliminar []
        .replace(/[<>]/g, '') // Eliminar <>
        .replace(/[()]/g, '') // Eliminar ()
        .replace(/[,]/g, '') // Eliminar comas
        .replace(/[.]/g, '') // Eliminar puntos
        // Reemplazar múltiples espacios con un solo guión
        .replace(/\s+/g, '-')
        // Reemplazar múltiples guiones consecutivos con uno solo
        .replace(/-+/g, '-')
        // Eliminar guiones al inicio y final
        .replace(/^-+|-+$/g, '')
        // Convertir a minúsculas
        .toLowerCase()
        // Limitar longitud para evitar URLs muy largas
        .substring(0, 100);
}

/**
 * Función para decodificar títulos de productos desde URL
 * @param {string} urlTitle - El título de la URL
 * @returns {string} - Título decodificado
 */
export function decodeProductTitle(urlTitle) {
    if (!urlTitle) return '';
    
    return urlTitle
        .replace(/-/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase()); // Capitalizar primera letra de cada palabra
} 